/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { ReactNode, useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { formatNumber } from 'shared/lib/utils/utils';
import { useApi } from 'app/api/APIProvider';
import Income from 'shared/assets/icons/HistoryPage/Income.svg';
import Outcome from 'shared/assets/icons/HistoryPage/outcome.svg';
import cls from './TransactionHistory.module.scss';

interface TransactionProps {
    transaction: any,
}

export const TransactionHistory = ({ transaction }: TransactionProps) => {
    const api = useApi();
    const { name, value } = transaction;
    const operation = value > 0 ? '+' : '';
    const icon = value > 0 ? <Income /> : <Outcome />;

    return (
        <div className={cls.card}>
            <div className={cls.content}>
                <div className={cls.contentElem}>
                    <div className={cls.icon}>
                        {icon}
                    </div>
                    <p>{name}</p>
                </div>
                <div className={cls.contentElem}>
                    <p className={cls.sum}>{operation} {formatNumber(value)} ₽</p>
                </div>
            </div>
        </div>
    );
};

